<template>
  <div id="all-country">

    <!-- 顶部搜索栏 -->
    <div class="country-search-top">
      <div class="country-search-box">
        <search-input :search="search" :size="'big'"></search-input>
      </div>
    </div>

    <!-- 国家列表栏 -->
    <div class="all-country-list">

      <el-tabs class="country-list-content" v-model="activeContinentName" @tab-click="activeContinent()">

        <el-tab-pane class="country-all-list" label="全部" name="all">
          <div class="country-all" v-for="(cont,index) in continents" :key="index">
            <div class="country-title">{{cn_name[cont.continent_id]}}</div>
            <div class="country-content" :class="index == continents.length-1?'no-border':''">
              <router-link  v-for="c in cont.country" :to="getProductRoute(c)" :key="c.visa_country_id">
                <span class="country-chinese">{{c.country}}</span>
              </router-link>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane v-for="(cont,index) in continents" :key="index" :label="cn_name[cont.continent_id]" :name="index+''">
          <div class="country-title">{{cn_name[cont.continent_id]}}</div>
          <div class="country-content">
            <router-link  v-for="c in cont.country" :to="getProductRoute(c)" :key="c.visa_country_id">
              <span class="country-chinese">{{c.country}}</span>
            </router-link>
          </div>
        </el-tab-pane>

      </el-tabs>

    </div>
  </div>
</template>

<script>
import searchInput from './components/country-search-input';
import Http from '../../libs/http';
import sensorService from '../../services/sensor-service';


export default {
  name: 'countries',
  components: {
    searchInput,
  },
  data() {
    return {
      continents: null,
      cn_name: ['亚洲', '欧洲', '美洲', '大洋洲', '非洲', '其他'],
      activeContinentName: 'all',
      search: [],
    };
  },
  methods: {
    activeContinent() {

      // 切换tab时更换地址栏中参数的值（让页面刷新后停留在当前tab）
      this.$router.replace({
        query: { continent_id: this.activeContinentName, ...this.$route.query },
      });

      // 动态设置tab底部蓝线宽度
      const activeContinentBottom = document.querySelector('.el-tabs__active-bar');
      if (this.activeContinentName === '3') {
        // 如果选择的 tab 是大洋洲时，让底部蓝线居中显示（蓝线宽度为两个汉字宽度，大洋洲三个字）。

        activeContinentBottom.style.left = '35px';
      } else {
        activeContinentBottom.style.left = '25px';
      }
    },
    getProductRoute(c) {
      const pageFrom = sensorService.getPageFrom();
      const route = { name: 'country', params: { id: c.visa_country_id }, query: { from: 'country_list_destination', ...pageFrom } };
      return route;
    },
  },
  created() {
    Http.post('/sys/visa_continent_query').then((data) => {
      this.continents = data.continent.concat({
        continent_id: 5,
        country: data.special_country.reduce((list, item) => {
          list.push(...item.country);
          return list;
        }, []).filter(item => item),
      });

      // 从其它页面跳转过来时
      this.activeContinentName = (this.$route.query.continent_id !== undefined) ? `${this.$route.query.continent_id}` : 'all';
      this.activeContinent();
    }).catch((e) => {
      if (e) console.log(e);
    });
    Http.post('/sys/visa_country_available_brief_query').then((data) => {
      this.search = data.result;
    }).catch((e) => {
      if (e) console.log(e);
    });
  },
};
</script>

<style lang="less" scope>
@import "../../assets/less/variable";

#all-country {
  background: #ffffff;

  // 顶部搜索栏
  .country-search-top {
    height: 80px;
    background-color: #5e9be1;
    margin-bottom: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
    .country-search-box {
      width: 1000px;
      height: 40px;

      .el-input__inner {
        border: none;
      }

      /* 输入框占位文本样式 */
      ::-moz-placeholder {
        color: #aaaaaa;
      }
      ::-webkit-input-placeholder {
        color: #aaaaaa;
      }
      :-ms-input-placeholder {
        color: #aaaaaa;
      }
    }
  }

  // 国家列表
  .all-country-list {
    width: 1000px;
    margin: 0 auto;
    min-height: 600px;
    padding-bottom: 50px;
    .country-list-title {
      font-size: 24px;
      color: #333333;
      font-weight: 600;
      text-align: center;
      padding: 39px 0 28px 0;
    }
    .country-list-content {
      display: block;
      .el-tabs__header {
        margin-bottom: 10px;
        border-bottom-color: #f0f0f0;
        .el-tabs__nav {
          right: 25px;
        }
        .el-tabs__item {
          padding: 0 25px 0;
          font-size: 16px;
          color: #777777;
          &.is-active {
            color: #5e9be1;
            font-size: 20px;
          }
          &:hover {
            color: #5e9be1;
          }
        }
        .el-tabs__active-bar {
          width: 40px!important;
          left: 25px;
          height: 2px;
          border-radius: 1px;
        }
      }
      .el-tab-pane {
        display: flex;
        margin-top: 34px;
        min-height: 300px;
        .country-title {
          width: 160px;
          font-size: 20px;
          color: #333333;
          flex-shrink: 0;
          font-weight: 700;
          position: relative;
          bottom: 6px;
        }
        .country-content {
          width: 100%;
          font-size: 0;
          padding-bottom: 10px;
          a {
            width: 210px;
            display: inline-block;
            margin-bottom: 20px;
            font-size: 16px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            line-height: 16px;
            .country-chinese {
              color: #333333;
            }
            .country-english {
              color: #aaaaaa;
            }
            &:hover {
              color: @blue;
              .country-chinese {
                color: @blue;
              }
              .country-english {
                color: @blue;
              }
            }
          }
        }
      }
      .country-all-list {
        margin-top: 0;
        flex-wrap: wrap;
        padding: 0;
        .country-all {
          width: 1000px;
          display: flex;
          margin-top: 34px;
          .country-content {
            border-bottom: 1px solid #f0f0f0;
            &.no-border {
              border-bottom: 0;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/countries/Countries.vue